// extracted by mini-css-extract-plugin
module.exports = {"openModalBtn":"ChangeClinic_openModalBtn__3Dkbl","footer":"ChangeClinic_footer__3d2EI"};